// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___zRBD","clinicsSelect":"styles_clinicsSelect__2Tnz3"};